// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__3ZqlL","label":"Section_label__3Mzud","contentWrap":"Section_contentWrap__WVnzh","footer":"Section_footer__2aN24","footerInner":"Section_footerInner__3d44O"};